"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLORS = exports.BG_COLORS = void 0;
var COLORS = exports.COLORS = {
  PRIMARY: 'var(--color-primary)',
  PRIMARY_100: 'var(--color-primary-100)',
  PRIMARY_200: 'var(--color-primary-200)',
  PRIMARY_300: 'var(--color-primary-300)',
  PRIMARY_400: 'var(--color-primary-400)',
  PRIMARY_500: 'var(--color-primary-500)',
  PRIMARY_600: 'var(--color-primary-600)',
  PRIMARY_700: 'var(--color-primary-700)',
  PRIMARY_800: 'var(--color-primary-800)',
  PRIMARY_900: 'var(--color-primary-900)',
  PREMIUM_PLUS: 'var(--color-premium-plus)',
  CATERED: 'var(--color-catered)',
  SUPER_DARK_BLUE: 'var(--color-super-dark-blue)',
  SOFT_BLUE: 'var(--color-soft-blue)',
  LIMITED: 'var(--color-limited)',
  SECONDARY_DARKER: 'var(--color-secondary-darker)',
  SECONDARY_DARK: 'var(--color-secondary-dark)',
  SECONDARY_LIGHT: 'var(--color-secondary-light)',
  SECONDARY_LIGHTER: 'var(--color-secondary-lighter)',
  PRIMARY_DARKER: 'var(--color-primary-darker)',
  PRIMARY_LIGHTER: 'var(--color-primary-lighter)',
  TERTIARY: 'var(--color-tertiary)',
  SECONDARY: 'var(--color-secondary)',
  BLACK: 'var(--color-black)',
  WHITE: 'var(--color-white)',
  CONTRAST_HIGHER: 'var(--color-contrast-higher)',
  CONTRAST_HIGH: 'var(--color-contrast-high)',
  CONTRAST_LOW: 'var(--color-contrast-low)',
  CONTRAST_LOWER: 'var(--color-contrast-lower)',
  CONTRAST_MEDIUM: 'var(--color-contrast-medium)',
  ERROR: 'var(--color-error)',
  ERROR_100: 'var(--color-error-100)',
  ERROR_200: 'var(--color-error-200)',
  ERROR_300: 'var(--color-error-300)',
  ERROR_400: 'var(--color-error-400)',
  ERROR_500: 'var(--color-error-500)',
  ERROR_600: 'var(--color-error-600)',
  ERROR_700: 'var(--color-error-700)',
  ERROR_800: 'var(--color-error-800)',
  ERROR_900: 'var(--color-error-900)',
  ORANGE: 'var(--color-orange)',
  ACCENT_DARKER: 'var(--color-accent-darker)',
  ACCENT_DARK: 'var(--color-accent-dark)',
  ACCENT: 'var(--color-accent)',
  ACCENT_LIGHT: 'var(--color-accent-light)',
  ACCENT_LIGHTER: 'var(--color-accent-lighter)',
  WARNING: 'var(--color-warning)',
  WARNING_100: 'var(--color-warning-100)',
  WARNING_200: 'var(--color-warning-200)',
  WARNING_300: 'var(--color-warning-300)',
  WARNING_400: 'var(--color-warning-400)',
  WARNING_500: 'var(--color-warning-500)',
  WARNING_600: 'var(--color-warning-600)',
  WARNING_700: 'var(--color-warning-700)',
  WARNING_800: 'var(--color-warning-800)',
  WARNING_900: 'var(--color-warning-900)',
  DAY8_LIGHT: 'var(--color-day8-light)',
  DAY8_LIGHTER: 'var(--color-day8-lighter)',
  DAY8_DARKER: 'var(--color-day8-darker)',
  DAY8_DARK: 'var(--color-day8-dark)',
  DAY8: 'var(--color-day8)',
  STANDARD: 'var(--color-standard)',
  SUCCESS: 'var(--color-success)',
  SUCCESS_100: 'var(--color-success-100)',
  SUCCESS_200: 'var(--color-success-200)',
  SUCCESS_300: 'var(--color-success-300)',
  SUCCESS_400: 'var(--color-success-400)',
  SUCCESS_500: 'var(--color-success-500)',
  SUCCESS_600: 'var(--color-success-600)',
  SUCCESS_700: 'var(--color-success-700)',
  SUCCESS_800: 'var(--color-success-800)',
  SUCCESS_900: 'var(--color-success-900)',
  NEON_GREEN: 'var(--color-neon-green)',
  BASIC: 'var(--color-basic)',
  BG: 'var(--color-bg)'
};
// export const COLORS = {
//   PRIMARY: () => 'hsl(208, 100%, 50%)',
//   PRIMARY_DARKER: () => 'hsl(208, 100%, 30%)',
//   SECONDARY: () => 'hsl(187, 71%, 49%)',
//   BLACK: () => 'hsl(0, 0%, 20%)',
//   WHITE: () => 'hsl(0, 0%, 100%)',
//   CONTRAST_HIGHER: () => 'hsl(0, 0%, 20%)',
//   CONTRAST_HIGH: () => 'hsl(220, 8%, 55%)',
//   CONTRAST_LOW: () => 'hsl(218, 22%, 90%)',
//   CONTRAST_LOWER: () => 'hsl(0, 0%, 96%)',
//   CONTRAST_MEDIUM: () => 'hsl(221, 12%, 73%)',
//   ERROR: () => 'hsl(0, 100%, 64%)',
//   WARNING: () => 'hsl(260, 96%, 56%)',
//   STANDARD: () => 'hsl(161, 76%, 58%)',
// };
// export const COLORS = {
//   PRIMARY: () => getComputedStyle(document.documentElement).getPropertyValue('--color-primary'),
//   SECONDARY: () => getComputedStyle(document.documentElement).getPropertyValue('--color-secondary'),
//   BLACK: () => getComputedStyle(document.documentElement).getPropertyValue('--color-black'),
//   WHITE: () => getComputedStyle(document.documentElement).getPropertyValue('--color-white'),
// };
var BG_COLORS = exports.BG_COLORS = {
  PRIMARY: 'd8-u-primary-bg',
  SECONDARY: 'd8-u-secondary-bg'
};